import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=71711553"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/PersonModal.vue
// module id = null
// module chunks = 